import { Component, OnInit, OnDestroy,Injectable } from '@angular/core';
import {Http, Headers, RequestOptions,Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {ShareService} from './../services/services';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/publishReplay';

let headers = new Headers();
headers.append('Access-Control-Allow-Origin', '*');
headers.append('Content-Type', 'application/x-www-form-urlencoded');
let options = new RequestOptions({ headers: headers });	 


@Injectable()
export class ServiceService {

  
     public _servicelist;
    constructor(
      private http: Http,
      
      private shareService: ShareService) {
        //this._servicelist = null;
  
    }
    getServicehomepage(slug:string,limit:string){
	     let headers = new Headers({'X-CSRF-TOKEN':this.shareService.getToken()});
	    headers.append('Access-Control-Allow-Origin', '*');
		headers.append('Content-Type', 'application/x-www-form-urlencoded');	
	    let options = new RequestOptions({ headers:headers });
	   	let apirul=this.shareService.getApiUrl()+'/servicelist/'+slug+'/'+limit;
	   //	if (!this._servicelist) { 	     
        let output= this.http.get(apirul,options)
             .map(res => res.json())
              .publishReplay(1)
			  .refCount()             
             .catch(this.handleError);
               
            
         //   }
            
         return output;
    }
	getServicelist(slug:string) {
	    let headers = new Headers({'X-CSRF-TOKEN':this.shareService.getToken()});
	    headers.append('Access-Control-Allow-Origin', '*');
		headers.append('Content-Type', 'application/x-www-form-urlencoded');	
	    let options = new RequestOptions({ headers:headers });
	   	let apirul=this.shareService.getApiUrl()+'/servicelist/'+slug;
	   //	if (!this._servicelist) { 	     
        this._servicelist = this.http.get(apirul,options)
             .map(res => res.json())
              .publishReplay(1)
			  .refCount()             
             .catch(this.handleError);
               
            
         //   }
            
         return this._servicelist;

	}
	
	getServicedetail(slug:string) {
	   let headers = new Headers({'X-CSRF-TOKEN':this.shareService.getToken()});
	    headers.append('Access-Control-Allow-Origin', '*');
		headers.append('Content-Type', 'application/x-www-form-urlencoded');	
	    let options = new RequestOptions({ headers:headers });
	   	let apirul=this.shareService.getApiUrl()+'/servicedetail/'+slug;	    	     
        let output= this.http.get(apirul,options)
             .map(res => res.json())
              .publishReplay(1)
			  .refCount()             
             .catch(this.handleError);
               
            
                      
         return output;

	    
	   	}
	
		
	handleError(error) {
        console.error("Got the error: " + JSON.stringify(error));
        return Observable.throw(error.json().error || 'Server error');
    }
}


// WEBPACK FOOTER //
// ./resources/assets/typescript/service/service.service.ts